import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const module = {
  namespaced: true,
  modules: {
    list: {
      namespaced: true,
      state,
      getters,
      actions,
      mutations,
    },
  },
};

export default module;


// WEBPACK FOOTER //
// ./src/modules/bids/vuex/index.js